import { SelectOption } from "./types";

export const CITY_OPTIONS: SelectOption[] = [
    { value: "Самара", label: "Самара" },
    { value: "Тольятти", label: "Тольятти" },
];

export const STORE_OPTIONS: SelectOption[] = [
    { value: "Ozon", label: "Ozon" },
    { value: "Wildberries", label: "Wildberries" },
    { value: "Яндекс Маркет", label: "Яндекс Маркет" },
];

// DOW: 1..7 (Пн..Вс)
export const DOW_OPTIONS: SelectOption[] = [
    { value: "1", label: "Пн" },
    { value: "2", label: "Вт" },
    { value: "3", label: "Ср" },
    { value: "4", label: "Чт" },
    { value: "5", label: "Пт" },
    { value: "6", label: "Сб" },
    { value: "7", label: "Вс" },
];
